import React from 'react';

const CreatedVideosLoading = () => {
  return (
    <div className="created-videos-container">
      {/* Sidebar Skeleton */}
      <div className="created-videos-sidebar">
        <div className="sidebar-skeleton">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="skeleton-menu-item" style={{ 
              height: '48px',
              marginBottom: '8px',
              borderRadius: '4px'
            }}></div>
          ))}
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="main-content">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="created-videos-skeleton">
            <div className="class-overview-skeleton">
              {/* Image Skeleton */}
              <div className="skeleton-thumbnail"></div>
              
              {/* Content Skeleton */}
              <div className="skeleton-content">
                <div className="skeleton-title"></div>
                <div className="skeleton-stats">
                  <div className="skeleton-stat-group">
                    <div className="skeleton-stat"></div>
                    <div className="skeleton-stat"></div>
                    <div className="skeleton-stat"></div>
                  </div>
                  <div className="skeleton-stat-group">
                    <div className="skeleton-stat"></div>
                    <div className="skeleton-stat"></div>
                  </div>
                </div>
              </div>
              
              {/* Actions Skeleton */}
              <div className="skeleton-actions">
                <div className="skeleton-button"></div>
                <div className="skeleton-button"></div>
              </div>
            </div>
            <div className="created-video-bottom-line"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreatedVideosLoading;